export const userConfigQueryKeys = {
  all: ['userConfig'] as const,

  config: () => [...userConfigQueryKeys.all, 'config'] as const,
};
